<div class="db-successful-popup">
  <div class="successful-popup-title" [innerHTML]="title"></div>
  <p class="successful-popup-desc" [innerHTML]="description"></p>
  <div class="db-button-wrap">
    <button class="ds-btn-black" (click)="activeModal.dismiss()"><span>{{'text_gotIt' | dbText}}</span></button>
  </div>
</div>
